import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isBefore from 'date-fns/isBefore'
import endOfToday from 'date-fns/endOfToday'
import { ScheduleCalendarCell } from 'components/Calendar'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { dateToString } from 'lib/helper'
import { getOrders } from 'reducks/checkout/selectors'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'
import addDays from 'date-fns/addDays'
const daysOfWeek = new DaysOfWeek()

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  individualSettingDates: Date[]
  row: Date[]
  selectDate: (date: Date) => void
}

const ScheduleCalendarRow: FC<Props> = (props) => {
  const { activeDates, businessDays, currentMonth, individualSettingDates, row, selectDate } = props

  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const closedDates = useSelector((state: State) => getClosedDates(state))
  const orders = useSelector((state: State) => getOrders(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDates.some((activeDate) => isSameDay(activeDate, date))
        const isClosed =
          closedDates.some((disabledDate) => isSameDay(disabledDate, date)) ||
          !businessDays.includes(daysOfWeek.getDayOfWeek(date, specialHolidays))
        const isOrdered = orders.some((order) => order.date === dateToString(date))
        const isSet = individualSettingDates.some((individualSettingDate) => {
          return isSameDay(individualSettingDate, date)
        })
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))

        return (
          <ScheduleCalendarCell
            currentMonth={currentMonth}
            key={getDate(date)}
            date={date}
            isActive={isActive}
            isBefore={isBefore(date, addDays(endOfToday(), -1))}
            isClosed={isClosed}
            isOrdered={isOrdered}
            isSet={isSet}
            isSpecialHoliday={isSpecialHoliday}
            selectDate={selectDate}
          />
        )
      })}
    </tr>
  )
}

export default ScheduleCalendarRow
